import React, {memo} from "react";
import Icon from "@ant-design/icons";

// Styles
import "./style/circle_icon.scss";

const CircleSvg = () => (
    <svg x="0px" y="0px" viewBox="0 0 512 512" fill="currentColor" className="circle_icon">
        <path d="M256,0C115.39,0,0,115.39,0,256s115.39,256,256,256s256-115.39,256-256S396.61,0,256,0z" />
    </svg>
);

const CircleIcon = () => {
    return (
        <Icon component={CircleSvg} />
    );
};

export default memo(CircleIcon);
